<template>
  <div class="cell" :class="cssClass">
    <div v-if="isFiltered" class="filter">
      <span class="icon-filter"></span>
    </div>
    <span class="text">{{ label }}</span>
    <div class="actions">
      <button
        v-if="hasSearch"
        class="button is-icon is-rounded"
        title="Search"
        @click="fireSearch(column, label)"
      >
        <span class="icon-eye"></span>
      </button>
      <button
        v-if="hasAdd"
        class="button is-icon is-rounded"
        title="Add"
        @click="fireAddRow"
      >
        <span class="icon-plus"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableHeaderCell',
  props: {
    cssClass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '',
      required: true
    },
    column: {
      type: String,
      default: ''
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    hasAdd: {
      type: Boolean,
      default: true
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isFiltered() {
      let has_filter = false;
      this.filters.map(item => {
        console.log(item.field, '___', this.column);
        if (item.field == this.column) has_filter = true;
      });
      return has_filter;
    }
  },
  methods: {
    fireSearch(column, label) {
      this.$emit('search', column, label);
    },
    fireAddRow() {
      this.$emit('add-row');
    },
    fireRemoveFilter(column) {
      console.log('remove filter');
      this.$emit('remove-filter', column);
    }
  }
};
</script>

<style scoped lang="scss">
.cell {
  font-weight: $weight-bold;
  border-right: solid 1px #eaeaea;
}

.filter {
  position: absolute;
  top: 12px;
  right: 6px;
  font-size: 18px;
  color: #000;
}
</style>
